define([
	"dojo/_base/declare",
	"csi/xml"
], function(declare,xml) {

	return declare(null, {
		getViewNodeReferenceAttrName: function() {
			// summary: only time when view node will not exist is when resolving for custom view migration
			var	node = this.getViewNode();
			if (!node) return xml.ATTR_PARENT;

			var nodeType = node.$Type;
			if (nodeType == "Season")
				// TODO figure out some way not to have to do this...
				return "ParentSeason";
			else if (nodeType == "MaterialSecurityGroup")
				return "MaterialSecurityGroups";
			else
				return nodeType;
		}
	});
});
